<template>
  <div class="rank-wrap">
    <img src="@/assets/img/rank-tips.png" class="tips" alt="">
    <div class="list-wrap">
      <div class="title">- 排行榜 -</div>
      <div class="col-title col">
        <div class="rank">排名</div>
        <div class="name">微信昵称</div>
        <div class="sum">邀请人数</div>
      </div>
      <div class="list">
        <div class="my-rank col" v-if="myRank && myRank.ranking">
          <div class="rank">{{myRank.ranking}}</div>
          <div class="name">{{myRank.nickname}}</div>
          <div class="sum">{{myRank.invite_count}}</div>
        </div>
        <van-list
          v-model="loading"
          :finished="finished"
          finished-text="没有更多了"
          @load="init"
        >
          <div class="item col" v-for="(item, index) in list" :key="index">
            <div class="rank" :data-value="index+1">{{index+1}}</div>
            <div class="name">{{item.nickname}}</div>
            <div class="sum">{{item.invite_count}}</div>
          </div>
        </van-list>
      </div>
    </div>
    <div class="button-wrap">
      <button @click="$router.push('/home')" v-log="'rank_to_home'" class="return-btn"></button>
      <button @click="$router.push('/prize')" v-log="'rank_to_prize'" class="prize-btn"></button>
    </div>
      <!-- <div class="button">
        <button @click="$router.push('home')" v-log="'rank_to_home'"></button>
      </div> -->
  </div>
</template>

<script>
import { List } from 'vant'

export default {
  name: 'rank',
  components: { [List.name]: List },
  data () {
    return {
      list: [],
      page: 1,
      finished: false,
      loading: false,
      myRank: null
    }
  },
  methods: {
    async init () {
      this.loading = true
      const { data } = await this.$fetch.get('/invited-lottery/ranking', {
        page: this.page++
      })
      this.myRank = data.meta.user_ranking
      this.list.push(...data.data)
      if (data.meta.pagination.count < data.meta.pagination.per_page || this.list.length > 1000) {
        this.finished = true
      }
      this.loading = false
    }
  },
  created () {

  }
}
</script>

<style lang='scss' scoped>
.rank-wrap{
  background: url(~@/assets/img/背景2.png) no-repeat;
  background-size: 100%;
  background-color: #f38483;
  min-height: 100vh;
  padding-top: 10px;
  .tips {
    width: 634px;
    display: block;
    margin: 50px auto 40px;
  }
  .list-wrap {
    width: 674px;
    height: 910px;
    margin: 20px auto;
    padding: 0 42px;
    background: #fff;
    border-radius:8px;
    .title {
      width: 674px;
      height: 83px;
      text-align: center;
      line-height: 83px;
      background: url(~@/assets/img/排行榜背景条.png) no-repeat;
      background-size: 100%;
      font-size:36px;
      color: #fff;
      position: relative;
      left: -42px;
    }
    .list {
      .item {
        height: 106px;
        position: relative;
        .rank {
          &::after {
            width:58px;
            height:64px;
            position: absolute;
            top: 20px;
            left: 18px;
            z-index: 1;
          }
        }
        &:nth-child(1) {
          .rank {
            &::after {
              content: '';
              background: url(~@/assets/img/1.png) no-repeat;
              background-size: 100%;
            }
          }
        }
        &:nth-child(2) {
          .rank {
            &::after {
              content: '';
              background: url(~@/assets/img/2.png) no-repeat;
              background-size: 100%;
            }
          }
        }
        &:nth-child(3) {
          .rank {
            &::after {
              content: '';
              background: url(~@/assets/img/3.png) no-repeat;
              background-size: 100%;
            }
          }
        }
      }
    }
    .col {
      font-size:26px;
      height: 82px;
      display: flex;
      align-items: center;
      border-bottom: 3px solid #e7e7e7;
      text-align: center;
      .rank {
        width: 100px;
      }
      .name {
        flex: 1;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
      .sum {
        width: 140px;
      }
    }
    .list {
      height: 742px;
      overflow: auto;
    }
  }
    .button-wrap {
      display: flex;
      justify-content: space-around;
      button {
        width: 313px;
        height: 97px;
        border: none;
        &.return-btn {
          background: url(~@/assets/img/返回抽奖.png) no-repeat;
          background-size: 100%;
        }
        &.prize-btn {
          background: url(~@/assets/img/我的奖品.png) no-repeat;
          background-size: 100%;
        }
      }
    }
  .button {
    width: 486px;
    margin: 30px auto 0;
    button {
      width: 100%;
      height: 110px;
      background: url('~@/assets/img/返回抽奖 2.png') no-repeat;
      background-size: 100%;
      padding-bottom: 20px;
      margin: 0 0 50px;
      color: #fff;
      border: none;
      font-size: 36px;
    }
  }
}
</style>
